import { render, staticRenderFns } from "./BlankPaySlipDetails.vue?vue&type=template&id=2bcfb89a&scoped=true&"
import script from "./BlankPaySlipDetails.vue?vue&type=script&lang=js&"
export * from "./BlankPaySlipDetails.vue?vue&type=script&lang=js&"
import style0 from "./BlankPaySlipDetails.vue?vue&type=style&index=0&id=2bcfb89a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bcfb89a",
  null
  
)

export default component.exports